import { getToRails, get } from "./api";
import isSSR from "venuescanner-js/services/isSSR";
import * as serviceURLs from "./serviceURLs.json";

export const getStyles = (base = "") =>
  get(`${base}/tags/style`, { returnData: false }).then((tags) =>
    tags.map((tag) => tag.name)
  );

const refDeferTo = (tags) => {
  const byName = tags.reduce((acc, tag) => {
    acc[tag.name] = tag;
    return acc;
  }, {});
  tags.forEach((tag) => {
    if (tag.defer_to && byName[tag.defer_to]) {
      tag.deferTo = byName[tag.defer_to];
    }
  });
};
const Tags = {
  versions: {
    standard: {
      url: serviceURLs.tags,
      tags: null,
      inflights: [],
    },
    extended: {
      url: serviceURLs.tagsExtended,
      tags: null,
      inflights: [],
    },
  },
  tags: null,
  inflights: [],
  fetch: async function (version = "standard") {
    if (!this.versions[version])
      throw new Error(`${version} is not an accepted tag version`);
    if (this.versions[version].tags) return this.versions[version].tags;
    return new Promise((resolve) => {
      this.versions[version].inflights.push(resolve);
      if (this.versions[version].inflights.length === 1) this.load(version);
    });
  },
  load: function (version = "standard") {
    if (isSSR()) {
      this.versions[version].tags = [];
      if (!isSSR()) {
        while (this.versions[version].inflights.length) {
          const resolve = this.versions[version].inflights.shift();
          resolve(this.versions[version].tags);
        }
      }
    } else {
      getToRails(this.versions[version].url, { returnData: false }).then(
        (tags) => {
          refDeferTo(tags);
          // console.log(tags)
          this.versions[version].tags = tags;
          while (this.versions[version].inflights.length) {
            const resolve = this.versions[version].inflights.shift();
            resolve(this.versions[version].tags);
          }
        }
      );
    }
  },
  find: async function (value, version = "standard") {
    const tags = await this.fetch(version);
    const bySlug = tags.find((t) => t.slug === value);
    if (bySlug) return bySlug;
    const byName = tags.find((t) => t.name === value);
    if (byName) return byName;
    return { label: value, name: value };
  },
};
if (typeof window !== "undefined") window.Tags = Tags;
export default Tags;
